import PlannerSettings from  '@/components/page/PlannerSettings';
import PlannerSettingsContext from '@/context/PlannerSettingsContext';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';

class PlannerSettingsPortal extends Component {
  render() {

    // Container ref
    const targetContainer = document.getElementById('react-planner-settings-container');
    
    // Dont load if container doesnt exist
    if (targetContainer === null){
        return null;
    }

    return ReactDOM.createPortal(
        <PlannerSettingsContext>
          <PlannerSettings />
        </PlannerSettingsContext>, targetContainer
    );
  }
}

export default PlannerSettingsPortal;